<template>
  <div class="i-date-picker-wrapper">
    <div class="inline-flex mr1">
      <input
        ref="day"
        class="i-cal-date"
        :class="{ 'i-invalid': showValidation && !validity.day}"
        placeholder="DD"
        pattern="0?[1-9]|[1-2][0-9]|3[0-1]"
        minlenght="2"
        maxlength="2"
        type="text"
        v-model="day">
      <input
        ref="month"
        class="i-cal-date"
        :class="{ 'i-invalid': showValidation && !validity.month}"
        placeholder="MM"
        pattern="0?[1-9]|1[0-2]"
        minlenght="2"
        maxlength="2"
        type="text"
        v-model="month">
      <input
        ref="year"
        class="i-cal-date i-cal-date-year"
        :class="{ 'i-invalid': showValidation && !validity.year}"
        placeholder="YYYY"
        pattern="[0-9]{4}"
        minlenght="4"
        maxlength="4"
        type="text"
        v-model="year">
    </div>
    <div class="inline-flex">
      <input
        class="i-cal-date"
        placeholder="hh"
        pattern="\d{2}"
        minlenght="2"
        maxlength="2"
        type="text"
        v-model="hours">
      <span>:</span>
      <input
        class="i-cal-date"
        placeholder="mm"
        pattern="\d{2}"
        minlenght="2"
        maxlength="2"
        type="text"
        v-model="minutes">
    </div>
    <i v-if="false" class="fa5 fas fa-calendar far" name="calendar"></i>
      <div class="date-error"></div>
  </div>
</template>

<script>
function isValidDate(d) {
  return d instanceof Date && !Number.isNaN(d);
}

export default {
  name: 'i-date-picker',
  props: {
    value: Date,
    showValidation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      year: '',
      month: '',
      day: '',
      hours: '',
      minutes: '',
    };
  },
  methods: {
    reset(date) {
      if (!isValidDate(date)) {
        this.year = '';
        this.month = '';
        this.day = '';
        this.hours = '';
        this.minutes = '';
      } else {
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.day = date.getDate();
        this.hours = date.getHours();
        this.minutes = date.getMinutes();
      }
    },
  },
  computed: {
    hasInput() {
      return [this.day, this.month, this.year]
        .some((v) => Boolean(v));
    },
    validity() {
      return {
        day: !this.hasInput || (Boolean(this.day) && this.$refs.day.validity.valid),
        month: !this.hasInput || (Boolean(this.month) && this.$refs.month.validity.valid),
        year: !this.hasInput || (Boolean(this.year) && this.$refs.year.validity.valid),
      };
    },
    valid() {
      return Object.values(this.validity)
        .every((v) => v === true);
    },
    date() {
      /* eslint-disable operator-linebreak */
      return (this.valid && this.hasInput) ?
        new Date(this.year, this.month - 1, this.day, this.hours, this.minutes) :
        null;
    },
  },
  watch: {
    date(d) {
      this.$emit('input', d);
    },
  },
};
</script>

<style scoped lang="scss">
  .i-date-picker-wrapper {
    display: flex;
    align-items: center;
    margin: 0 -2px;
    max-width: 280px;
    line-height: 30px;
  }

  .i-cal-date {
      flex-grow: 1;
      padding: 5px;
      font-family: $font-family-regular;
      font-size: 13px;
      height: 30px;
      width: 100%;
      border: 1px solid #bababa !important;
      margin: 0 2px !important;
      min-width: 35px;

      &.i-invalid {
        border-color: $red !important;
        outline-color: $red;
      }
  }

  .i-cal-date-year {
    min-width: 50px;
  }
</style>
